// source: apigateway/profile/search.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.profile.SearchAge', null, global);
goog.exportSymbol('proto.profile.SearchAward', null, global);
goog.exportSymbol('proto.profile.SearchCareer', null, global);
goog.exportSymbol('proto.profile.SearchJob', null, global);
goog.exportSymbol('proto.profile.SearchLicense', null, global);
goog.exportSymbol('proto.profile.SearchPortfolio', null, global);
goog.exportSymbol('proto.profile.SearchPortfolioImage', null, global);
goog.exportSymbol('proto.profile.SearchPortfolioVideo', null, global);
goog.exportSymbol('proto.profile.SearchPrefecture', null, global);
goog.exportSymbol('proto.profile.SearchPrice', null, global);
goog.exportSymbol('proto.profile.SearchPriceItem', null, global);
goog.exportSymbol('proto.profile.SearchProviderCompany', null, global);
goog.exportSymbol('proto.profile.SearchProviderLevel', null, global);
goog.exportSymbol('proto.profile.SearchSex', null, global);
goog.exportSymbol('proto.profile.SearchSkill', null, global);
goog.exportSymbol('proto.profile.SearchSkillLevel', null, global);
goog.exportSymbol('proto.profile.SearchUserStatus', null, global);
goog.exportSymbol('proto.profile.SearchUsersReply', null, global);
goog.exportSymbol('proto.profile.SearchUsersRequest', null, global);
goog.exportSymbol('proto.profile.UserSearch', null, global);
goog.exportSymbol('proto.profile.UserSearchSpecialty', null, global);
goog.exportSymbol('proto.profile.UserSearchSpecialtyDetail', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.UserSearch = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profile.UserSearch.repeatedFields_, null);
};
goog.inherits(proto.profile.UserSearch, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.UserSearch.displayName = 'proto.profile.UserSearch';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchUsersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profile.SearchUsersRequest.repeatedFields_, null);
};
goog.inherits(proto.profile.SearchUsersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchUsersRequest.displayName = 'proto.profile.SearchUsersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchUsersReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profile.SearchUsersReply.repeatedFields_, null);
};
goog.inherits(proto.profile.SearchUsersReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchUsersReply.displayName = 'proto.profile.SearchUsersReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchProviderCompany = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profile.SearchProviderCompany, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchProviderCompany.displayName = 'proto.profile.SearchProviderCompany';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.UserSearchSpecialty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profile.UserSearchSpecialty.repeatedFields_, null);
};
goog.inherits(proto.profile.UserSearchSpecialty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.UserSearchSpecialty.displayName = 'proto.profile.UserSearchSpecialty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.UserSearchSpecialtyDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profile.UserSearchSpecialtyDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.UserSearchSpecialtyDetail.displayName = 'proto.profile.UserSearchSpecialtyDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchSkill = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profile.SearchSkill, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchSkill.displayName = 'proto.profile.SearchSkill';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchSkillLevel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profile.SearchSkillLevel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchSkillLevel.displayName = 'proto.profile.SearchSkillLevel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchAge = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profile.SearchAge, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchAge.displayName = 'proto.profile.SearchAge';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchProviderLevel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profile.SearchProviderLevel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchProviderLevel.displayName = 'proto.profile.SearchProviderLevel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchSex = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profile.SearchSex, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchSex.displayName = 'proto.profile.SearchSex';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchPrefecture = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profile.SearchPrefecture, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchPrefecture.displayName = 'proto.profile.SearchPrefecture';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchUserStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profile.SearchUserStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchUserStatus.displayName = 'proto.profile.SearchUserStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchJob = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profile.SearchJob, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchJob.displayName = 'proto.profile.SearchJob';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchLicense = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profile.SearchLicense, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchLicense.displayName = 'proto.profile.SearchLicense';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchCareer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profile.SearchCareer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchCareer.displayName = 'proto.profile.SearchCareer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchAward = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profile.SearchAward, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchAward.displayName = 'proto.profile.SearchAward';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchPortfolio = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profile.SearchPortfolio, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchPortfolio.displayName = 'proto.profile.SearchPortfolio';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchPortfolioImage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profile.SearchPortfolioImage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchPortfolioImage.displayName = 'proto.profile.SearchPortfolioImage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchPortfolioVideo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profile.SearchPortfolioVideo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchPortfolioVideo.displayName = 'proto.profile.SearchPortfolioVideo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchPrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profile.SearchPrice.repeatedFields_, null);
};
goog.inherits(proto.profile.SearchPrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchPrice.displayName = 'proto.profile.SearchPrice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profile.SearchPriceItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profile.SearchPriceItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profile.SearchPriceItem.displayName = 'proto.profile.SearchPriceItem';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profile.UserSearch.repeatedFields_ = [25,26,27,28,29,30,31,32,33,34];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.UserSearch.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.UserSearch.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.UserSearch} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.UserSearch.toObject = function(includeInstance, msg) {
  var f, obj = {
    company: (f = msg.getCompany()) && proto.profile.SearchProviderCompany.toObject(includeInstance, f),
    ndaIdentification: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    phoneAuthorization: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    userAuthorization: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    lastLogin: jspb.Message.getFieldWithDefault(msg, 5, 0),
    userCreated: jspb.Message.getFieldWithDefault(msg, 6, 0),
    averageRating: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    age: (f = msg.getAge()) && proto.profile.SearchAge.toObject(includeInstance, f),
    coconalaScore: jspb.Message.getFieldWithDefault(msg, 9, 0),
    followerCount: jspb.Message.getFieldWithDefault(msg, 10, 0),
    paidOrderCount: jspb.Message.getFieldWithDefault(msg, 11, 0),
    providerLevel: (f = msg.getProviderLevel()) && proto.profile.SearchProviderLevel.toObject(includeInstance, f),
    sex: (f = msg.getSex()) && proto.profile.SearchSex.toObject(includeInstance, f),
    isPro: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    userId: jspb.Message.getFieldWithDefault(msg, 15, 0),
    profileImage: jspb.Message.getFieldWithDefault(msg, 16, ""),
    profileText: jspb.Message.getFieldWithDefault(msg, 17, ""),
    userName: jspb.Message.getFieldWithDefault(msg, 18, ""),
    occupation: jspb.Message.getFieldWithDefault(msg, 19, ""),
    isDisplayAge: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
    prefecture: (f = msg.getPrefecture()) && proto.profile.SearchPrefecture.toObject(includeInstance, f),
    locationText: jspb.Message.getFieldWithDefault(msg, 22, ""),
    userStatus: (f = msg.getUserStatus()) && proto.profile.SearchUserStatus.toObject(includeInstance, f),
    catchphrase: jspb.Message.getFieldWithDefault(msg, 24, ""),
    jobsList: jspb.Message.toObjectList(msg.getJobsList(),
    proto.profile.SearchJob.toObject, includeInstance),
    userSpecialtiesList: jspb.Message.toObjectList(msg.getUserSpecialtiesList(),
    proto.profile.UserSearchSpecialty.toObject, includeInstance),
    userSpecialtyTagsList: (f = jspb.Message.getRepeatedField(msg, 27)) == null ? undefined : f,
    skillsList: jspb.Message.toObjectList(msg.getSkillsList(),
    proto.profile.SearchSkill.toObject, includeInstance),
    licensesList: jspb.Message.toObjectList(msg.getLicensesList(),
    proto.profile.SearchLicense.toObject, includeInstance),
    careersList: jspb.Message.toObjectList(msg.getCareersList(),
    proto.profile.SearchCareer.toObject, includeInstance),
    awardsList: jspb.Message.toObjectList(msg.getAwardsList(),
    proto.profile.SearchAward.toObject, includeInstance),
    portfoliosList: jspb.Message.toObjectList(msg.getPortfoliosList(),
    proto.profile.SearchPortfolio.toObject, includeInstance),
    portfolioTagsList: (f = jspb.Message.getRepeatedField(msg, 33)) == null ? undefined : f,
    pricesList: jspb.Message.toObjectList(msg.getPricesList(),
    proto.profile.SearchPrice.toObject, includeInstance),
    isFollowed: jspb.Message.getBooleanFieldWithDefault(msg, 35, false),
    profileImagePath: jspb.Message.getFieldWithDefault(msg, 36, ""),
    isIdentificationNormalized: jspb.Message.getBooleanFieldWithDefault(msg, 37, false),
    isSoloProprietorship: jspb.Message.getBooleanFieldWithDefault(msg, 38, false),
    resizableProfileIcon: jspb.Message.getFieldWithDefault(msg, 39, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.UserSearch}
 */
proto.profile.UserSearch.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.UserSearch;
  return proto.profile.UserSearch.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.UserSearch} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.UserSearch}
 */
proto.profile.UserSearch.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.profile.SearchProviderCompany;
      reader.readMessage(value,proto.profile.SearchProviderCompany.deserializeBinaryFromReader);
      msg.setCompany(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNdaIdentification(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPhoneAuthorization(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserAuthorization(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastLogin(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserCreated(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAverageRating(value);
      break;
    case 8:
      var value = new proto.profile.SearchAge;
      reader.readMessage(value,proto.profile.SearchAge.deserializeBinaryFromReader);
      msg.setAge(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCoconalaScore(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFollowerCount(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaidOrderCount(value);
      break;
    case 12:
      var value = new proto.profile.SearchProviderLevel;
      reader.readMessage(value,proto.profile.SearchProviderLevel.deserializeBinaryFromReader);
      msg.setProviderLevel(value);
      break;
    case 13:
      var value = new proto.profile.SearchSex;
      reader.readMessage(value,proto.profile.SearchSex.deserializeBinaryFromReader);
      msg.setSex(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPro(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileImage(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileText(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setOccupation(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDisplayAge(value);
      break;
    case 21:
      var value = new proto.profile.SearchPrefecture;
      reader.readMessage(value,proto.profile.SearchPrefecture.deserializeBinaryFromReader);
      msg.setPrefecture(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocationText(value);
      break;
    case 23:
      var value = new proto.profile.SearchUserStatus;
      reader.readMessage(value,proto.profile.SearchUserStatus.deserializeBinaryFromReader);
      msg.setUserStatus(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setCatchphrase(value);
      break;
    case 25:
      var value = new proto.profile.SearchJob;
      reader.readMessage(value,proto.profile.SearchJob.deserializeBinaryFromReader);
      msg.addJobs(value);
      break;
    case 26:
      var value = new proto.profile.UserSearchSpecialty;
      reader.readMessage(value,proto.profile.UserSearchSpecialty.deserializeBinaryFromReader);
      msg.addUserSpecialties(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserSpecialtyTags(value);
      break;
    case 28:
      var value = new proto.profile.SearchSkill;
      reader.readMessage(value,proto.profile.SearchSkill.deserializeBinaryFromReader);
      msg.addSkills(value);
      break;
    case 29:
      var value = new proto.profile.SearchLicense;
      reader.readMessage(value,proto.profile.SearchLicense.deserializeBinaryFromReader);
      msg.addLicenses(value);
      break;
    case 30:
      var value = new proto.profile.SearchCareer;
      reader.readMessage(value,proto.profile.SearchCareer.deserializeBinaryFromReader);
      msg.addCareers(value);
      break;
    case 31:
      var value = new proto.profile.SearchAward;
      reader.readMessage(value,proto.profile.SearchAward.deserializeBinaryFromReader);
      msg.addAwards(value);
      break;
    case 32:
      var value = new proto.profile.SearchPortfolio;
      reader.readMessage(value,proto.profile.SearchPortfolio.deserializeBinaryFromReader);
      msg.addPortfolios(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.addPortfolioTags(value);
      break;
    case 34:
      var value = new proto.profile.SearchPrice;
      reader.readMessage(value,proto.profile.SearchPrice.deserializeBinaryFromReader);
      msg.addPrices(value);
      break;
    case 35:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFollowed(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileImagePath(value);
      break;
    case 37:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsIdentificationNormalized(value);
      break;
    case 38:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSoloProprietorship(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setResizableProfileIcon(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.UserSearch.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.UserSearch.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.UserSearch} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.UserSearch.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompany();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.profile.SearchProviderCompany.serializeBinaryToWriter
    );
  }
  f = message.getNdaIdentification();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getPhoneAuthorization();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getUserAuthorization();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getLastLogin();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getUserCreated();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAverageRating();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getAge();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.profile.SearchAge.serializeBinaryToWriter
    );
  }
  f = message.getCoconalaScore();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getFollowerCount();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getPaidOrderCount();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getProviderLevel();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.profile.SearchProviderLevel.serializeBinaryToWriter
    );
  }
  f = message.getSex();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.profile.SearchSex.serializeBinaryToWriter
    );
  }
  f = message.getIsPro();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getProfileImage();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getProfileText();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getOccupation();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getIsDisplayAge();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getPrefecture();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.profile.SearchPrefecture.serializeBinaryToWriter
    );
  }
  f = message.getLocationText();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getUserStatus();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.profile.SearchUserStatus.serializeBinaryToWriter
    );
  }
  f = message.getCatchphrase();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getJobsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      25,
      f,
      proto.profile.SearchJob.serializeBinaryToWriter
    );
  }
  f = message.getUserSpecialtiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      26,
      f,
      proto.profile.UserSearchSpecialty.serializeBinaryToWriter
    );
  }
  f = message.getUserSpecialtyTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      27,
      f
    );
  }
  f = message.getSkillsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      28,
      f,
      proto.profile.SearchSkill.serializeBinaryToWriter
    );
  }
  f = message.getLicensesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      29,
      f,
      proto.profile.SearchLicense.serializeBinaryToWriter
    );
  }
  f = message.getCareersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      30,
      f,
      proto.profile.SearchCareer.serializeBinaryToWriter
    );
  }
  f = message.getAwardsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      31,
      f,
      proto.profile.SearchAward.serializeBinaryToWriter
    );
  }
  f = message.getPortfoliosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      32,
      f,
      proto.profile.SearchPortfolio.serializeBinaryToWriter
    );
  }
  f = message.getPortfolioTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      33,
      f
    );
  }
  f = message.getPricesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      34,
      f,
      proto.profile.SearchPrice.serializeBinaryToWriter
    );
  }
  f = message.getIsFollowed();
  if (f) {
    writer.writeBool(
      35,
      f
    );
  }
  f = message.getProfileImagePath();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getIsIdentificationNormalized();
  if (f) {
    writer.writeBool(
      37,
      f
    );
  }
  f = message.getIsSoloProprietorship();
  if (f) {
    writer.writeBool(
      38,
      f
    );
  }
  f = message.getResizableProfileIcon();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
};


/**
 * optional SearchProviderCompany company = 1;
 * @return {?proto.profile.SearchProviderCompany}
 */
proto.profile.UserSearch.prototype.getCompany = function() {
  return /** @type{?proto.profile.SearchProviderCompany} */ (
    jspb.Message.getWrapperField(this, proto.profile.SearchProviderCompany, 1));
};


/**
 * @param {?proto.profile.SearchProviderCompany|undefined} value
 * @return {!proto.profile.UserSearch} returns this
*/
proto.profile.UserSearch.prototype.setCompany = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.clearCompany = function() {
  return this.setCompany(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profile.UserSearch.prototype.hasCompany = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool nda_identification = 2;
 * @return {boolean}
 */
proto.profile.UserSearch.prototype.getNdaIdentification = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setNdaIdentification = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool phone_authorization = 3;
 * @return {boolean}
 */
proto.profile.UserSearch.prototype.getPhoneAuthorization = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setPhoneAuthorization = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool user_authorization = 4;
 * @return {boolean}
 */
proto.profile.UserSearch.prototype.getUserAuthorization = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setUserAuthorization = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional int64 last_login = 5;
 * @return {number}
 */
proto.profile.UserSearch.prototype.getLastLogin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setLastLogin = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 user_created = 6;
 * @return {number}
 */
proto.profile.UserSearch.prototype.getUserCreated = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setUserCreated = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional float average_rating = 7;
 * @return {number}
 */
proto.profile.UserSearch.prototype.getAverageRating = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setAverageRating = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional SearchAge age = 8;
 * @return {?proto.profile.SearchAge}
 */
proto.profile.UserSearch.prototype.getAge = function() {
  return /** @type{?proto.profile.SearchAge} */ (
    jspb.Message.getWrapperField(this, proto.profile.SearchAge, 8));
};


/**
 * @param {?proto.profile.SearchAge|undefined} value
 * @return {!proto.profile.UserSearch} returns this
*/
proto.profile.UserSearch.prototype.setAge = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.clearAge = function() {
  return this.setAge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profile.UserSearch.prototype.hasAge = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional int32 coconala_score = 9;
 * @return {number}
 */
proto.profile.UserSearch.prototype.getCoconalaScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setCoconalaScore = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 follower_count = 10;
 * @return {number}
 */
proto.profile.UserSearch.prototype.getFollowerCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setFollowerCount = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 paid_order_count = 11;
 * @return {number}
 */
proto.profile.UserSearch.prototype.getPaidOrderCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setPaidOrderCount = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional SearchProviderLevel provider_level = 12;
 * @return {?proto.profile.SearchProviderLevel}
 */
proto.profile.UserSearch.prototype.getProviderLevel = function() {
  return /** @type{?proto.profile.SearchProviderLevel} */ (
    jspb.Message.getWrapperField(this, proto.profile.SearchProviderLevel, 12));
};


/**
 * @param {?proto.profile.SearchProviderLevel|undefined} value
 * @return {!proto.profile.UserSearch} returns this
*/
proto.profile.UserSearch.prototype.setProviderLevel = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.clearProviderLevel = function() {
  return this.setProviderLevel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profile.UserSearch.prototype.hasProviderLevel = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional SearchSex sex = 13;
 * @return {?proto.profile.SearchSex}
 */
proto.profile.UserSearch.prototype.getSex = function() {
  return /** @type{?proto.profile.SearchSex} */ (
    jspb.Message.getWrapperField(this, proto.profile.SearchSex, 13));
};


/**
 * @param {?proto.profile.SearchSex|undefined} value
 * @return {!proto.profile.UserSearch} returns this
*/
proto.profile.UserSearch.prototype.setSex = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.clearSex = function() {
  return this.setSex(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profile.UserSearch.prototype.hasSex = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional bool is_pro = 14;
 * @return {boolean}
 */
proto.profile.UserSearch.prototype.getIsPro = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setIsPro = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional int32 user_id = 15;
 * @return {number}
 */
proto.profile.UserSearch.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string profile_image = 16;
 * @return {string}
 */
proto.profile.UserSearch.prototype.getProfileImage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setProfileImage = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string profile_text = 17;
 * @return {string}
 */
proto.profile.UserSearch.prototype.getProfileText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setProfileText = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string user_name = 18;
 * @return {string}
 */
proto.profile.UserSearch.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string occupation = 19;
 * @return {string}
 */
proto.profile.UserSearch.prototype.getOccupation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setOccupation = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional bool is_display_age = 20;
 * @return {boolean}
 */
proto.profile.UserSearch.prototype.getIsDisplayAge = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setIsDisplayAge = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional SearchPrefecture prefecture = 21;
 * @return {?proto.profile.SearchPrefecture}
 */
proto.profile.UserSearch.prototype.getPrefecture = function() {
  return /** @type{?proto.profile.SearchPrefecture} */ (
    jspb.Message.getWrapperField(this, proto.profile.SearchPrefecture, 21));
};


/**
 * @param {?proto.profile.SearchPrefecture|undefined} value
 * @return {!proto.profile.UserSearch} returns this
*/
proto.profile.UserSearch.prototype.setPrefecture = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.clearPrefecture = function() {
  return this.setPrefecture(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profile.UserSearch.prototype.hasPrefecture = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional string location_text = 22;
 * @return {string}
 */
proto.profile.UserSearch.prototype.getLocationText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setLocationText = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional SearchUserStatus user_status = 23;
 * @return {?proto.profile.SearchUserStatus}
 */
proto.profile.UserSearch.prototype.getUserStatus = function() {
  return /** @type{?proto.profile.SearchUserStatus} */ (
    jspb.Message.getWrapperField(this, proto.profile.SearchUserStatus, 23));
};


/**
 * @param {?proto.profile.SearchUserStatus|undefined} value
 * @return {!proto.profile.UserSearch} returns this
*/
proto.profile.UserSearch.prototype.setUserStatus = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.clearUserStatus = function() {
  return this.setUserStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profile.UserSearch.prototype.hasUserStatus = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional string catchphrase = 24;
 * @return {string}
 */
proto.profile.UserSearch.prototype.getCatchphrase = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setCatchphrase = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * repeated SearchJob jobs = 25;
 * @return {!Array<!proto.profile.SearchJob>}
 */
proto.profile.UserSearch.prototype.getJobsList = function() {
  return /** @type{!Array<!proto.profile.SearchJob>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profile.SearchJob, 25));
};


/**
 * @param {!Array<!proto.profile.SearchJob>} value
 * @return {!proto.profile.UserSearch} returns this
*/
proto.profile.UserSearch.prototype.setJobsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 25, value);
};


/**
 * @param {!proto.profile.SearchJob=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profile.SearchJob}
 */
proto.profile.UserSearch.prototype.addJobs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 25, opt_value, proto.profile.SearchJob, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.clearJobsList = function() {
  return this.setJobsList([]);
};


/**
 * repeated UserSearchSpecialty user_specialties = 26;
 * @return {!Array<!proto.profile.UserSearchSpecialty>}
 */
proto.profile.UserSearch.prototype.getUserSpecialtiesList = function() {
  return /** @type{!Array<!proto.profile.UserSearchSpecialty>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profile.UserSearchSpecialty, 26));
};


/**
 * @param {!Array<!proto.profile.UserSearchSpecialty>} value
 * @return {!proto.profile.UserSearch} returns this
*/
proto.profile.UserSearch.prototype.setUserSpecialtiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 26, value);
};


/**
 * @param {!proto.profile.UserSearchSpecialty=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profile.UserSearchSpecialty}
 */
proto.profile.UserSearch.prototype.addUserSpecialties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 26, opt_value, proto.profile.UserSearchSpecialty, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.clearUserSpecialtiesList = function() {
  return this.setUserSpecialtiesList([]);
};


/**
 * repeated string user_specialty_tags = 27;
 * @return {!Array<string>}
 */
proto.profile.UserSearch.prototype.getUserSpecialtyTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 27));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setUserSpecialtyTagsList = function(value) {
  return jspb.Message.setField(this, 27, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.addUserSpecialtyTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 27, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.clearUserSpecialtyTagsList = function() {
  return this.setUserSpecialtyTagsList([]);
};


/**
 * repeated SearchSkill skills = 28;
 * @return {!Array<!proto.profile.SearchSkill>}
 */
proto.profile.UserSearch.prototype.getSkillsList = function() {
  return /** @type{!Array<!proto.profile.SearchSkill>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profile.SearchSkill, 28));
};


/**
 * @param {!Array<!proto.profile.SearchSkill>} value
 * @return {!proto.profile.UserSearch} returns this
*/
proto.profile.UserSearch.prototype.setSkillsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 28, value);
};


/**
 * @param {!proto.profile.SearchSkill=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profile.SearchSkill}
 */
proto.profile.UserSearch.prototype.addSkills = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 28, opt_value, proto.profile.SearchSkill, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.clearSkillsList = function() {
  return this.setSkillsList([]);
};


/**
 * repeated SearchLicense licenses = 29;
 * @return {!Array<!proto.profile.SearchLicense>}
 */
proto.profile.UserSearch.prototype.getLicensesList = function() {
  return /** @type{!Array<!proto.profile.SearchLicense>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profile.SearchLicense, 29));
};


/**
 * @param {!Array<!proto.profile.SearchLicense>} value
 * @return {!proto.profile.UserSearch} returns this
*/
proto.profile.UserSearch.prototype.setLicensesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 29, value);
};


/**
 * @param {!proto.profile.SearchLicense=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profile.SearchLicense}
 */
proto.profile.UserSearch.prototype.addLicenses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 29, opt_value, proto.profile.SearchLicense, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.clearLicensesList = function() {
  return this.setLicensesList([]);
};


/**
 * repeated SearchCareer careers = 30;
 * @return {!Array<!proto.profile.SearchCareer>}
 */
proto.profile.UserSearch.prototype.getCareersList = function() {
  return /** @type{!Array<!proto.profile.SearchCareer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profile.SearchCareer, 30));
};


/**
 * @param {!Array<!proto.profile.SearchCareer>} value
 * @return {!proto.profile.UserSearch} returns this
*/
proto.profile.UserSearch.prototype.setCareersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 30, value);
};


/**
 * @param {!proto.profile.SearchCareer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profile.SearchCareer}
 */
proto.profile.UserSearch.prototype.addCareers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 30, opt_value, proto.profile.SearchCareer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.clearCareersList = function() {
  return this.setCareersList([]);
};


/**
 * repeated SearchAward awards = 31;
 * @return {!Array<!proto.profile.SearchAward>}
 */
proto.profile.UserSearch.prototype.getAwardsList = function() {
  return /** @type{!Array<!proto.profile.SearchAward>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profile.SearchAward, 31));
};


/**
 * @param {!Array<!proto.profile.SearchAward>} value
 * @return {!proto.profile.UserSearch} returns this
*/
proto.profile.UserSearch.prototype.setAwardsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 31, value);
};


/**
 * @param {!proto.profile.SearchAward=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profile.SearchAward}
 */
proto.profile.UserSearch.prototype.addAwards = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 31, opt_value, proto.profile.SearchAward, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.clearAwardsList = function() {
  return this.setAwardsList([]);
};


/**
 * repeated SearchPortfolio portfolios = 32;
 * @return {!Array<!proto.profile.SearchPortfolio>}
 */
proto.profile.UserSearch.prototype.getPortfoliosList = function() {
  return /** @type{!Array<!proto.profile.SearchPortfolio>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profile.SearchPortfolio, 32));
};


/**
 * @param {!Array<!proto.profile.SearchPortfolio>} value
 * @return {!proto.profile.UserSearch} returns this
*/
proto.profile.UserSearch.prototype.setPortfoliosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 32, value);
};


/**
 * @param {!proto.profile.SearchPortfolio=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profile.SearchPortfolio}
 */
proto.profile.UserSearch.prototype.addPortfolios = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 32, opt_value, proto.profile.SearchPortfolio, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.clearPortfoliosList = function() {
  return this.setPortfoliosList([]);
};


/**
 * repeated string portfolio_tags = 33;
 * @return {!Array<string>}
 */
proto.profile.UserSearch.prototype.getPortfolioTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 33));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setPortfolioTagsList = function(value) {
  return jspb.Message.setField(this, 33, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.addPortfolioTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 33, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.clearPortfolioTagsList = function() {
  return this.setPortfolioTagsList([]);
};


/**
 * repeated SearchPrice prices = 34;
 * @return {!Array<!proto.profile.SearchPrice>}
 */
proto.profile.UserSearch.prototype.getPricesList = function() {
  return /** @type{!Array<!proto.profile.SearchPrice>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profile.SearchPrice, 34));
};


/**
 * @param {!Array<!proto.profile.SearchPrice>} value
 * @return {!proto.profile.UserSearch} returns this
*/
proto.profile.UserSearch.prototype.setPricesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 34, value);
};


/**
 * @param {!proto.profile.SearchPrice=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profile.SearchPrice}
 */
proto.profile.UserSearch.prototype.addPrices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 34, opt_value, proto.profile.SearchPrice, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.clearPricesList = function() {
  return this.setPricesList([]);
};


/**
 * optional bool is_followed = 35;
 * @return {boolean}
 */
proto.profile.UserSearch.prototype.getIsFollowed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 35, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setIsFollowed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 35, value);
};


/**
 * optional string profile_image_path = 36;
 * @return {string}
 */
proto.profile.UserSearch.prototype.getProfileImagePath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setProfileImagePath = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional bool is_identification_normalized = 37;
 * @return {boolean}
 */
proto.profile.UserSearch.prototype.getIsIdentificationNormalized = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 37, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setIsIdentificationNormalized = function(value) {
  return jspb.Message.setProto3BooleanField(this, 37, value);
};


/**
 * optional bool is_solo_proprietorship = 38;
 * @return {boolean}
 */
proto.profile.UserSearch.prototype.getIsSoloProprietorship = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 38, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setIsSoloProprietorship = function(value) {
  return jspb.Message.setProto3BooleanField(this, 38, value);
};


/**
 * optional string resizable_profile_icon = 39;
 * @return {string}
 */
proto.profile.UserSearch.prototype.getResizableProfileIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.UserSearch} returns this
 */
proto.profile.UserSearch.prototype.setResizableProfileIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profile.SearchUsersRequest.repeatedFields_ = [4,10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchUsersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchUsersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchUsersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchUsersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    page: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    keyword: jspb.Message.getFieldWithDefault(msg, 3, ""),
    jobIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    proPriority: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    delivery: jspb.Message.getFieldWithDefault(msg, 6, 0),
    identification: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    loginDays: jspb.Message.getFieldWithDefault(msg, 8, 0),
    userStatus: jspb.Message.getFieldWithDefault(msg, 9, 0),
    registrationsList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    businessFlag: jspb.Message.getBooleanFieldWithDefault(msg, 11, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchUsersRequest}
 */
proto.profile.SearchUsersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchUsersRequest;
  return proto.profile.SearchUsersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchUsersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchUsersRequest}
 */
proto.profile.SearchUsersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyword(value);
      break;
    case 4:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setJobIdsList(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProPriority(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDelivery(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIdentification(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLoginDays(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserStatus(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addRegistrations(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBusinessFlag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchUsersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchUsersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchUsersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchUsersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getKeyword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getJobIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      4,
      f
    );
  }
  f = message.getProPriority();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getDelivery();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getIdentification();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getLoginDays();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getUserStatus();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getRegistrationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getBusinessFlag();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.profile.SearchUsersRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchUsersRequest} returns this
 */
proto.profile.SearchUsersRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.profile.SearchUsersRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchUsersRequest} returns this
 */
proto.profile.SearchUsersRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string keyword = 3;
 * @return {string}
 */
proto.profile.SearchUsersRequest.prototype.getKeyword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchUsersRequest} returns this
 */
proto.profile.SearchUsersRequest.prototype.setKeyword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated int32 job_ids = 4;
 * @return {!Array<number>}
 */
proto.profile.SearchUsersRequest.prototype.getJobIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profile.SearchUsersRequest} returns this
 */
proto.profile.SearchUsersRequest.prototype.setJobIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profile.SearchUsersRequest} returns this
 */
proto.profile.SearchUsersRequest.prototype.addJobIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profile.SearchUsersRequest} returns this
 */
proto.profile.SearchUsersRequest.prototype.clearJobIdsList = function() {
  return this.setJobIdsList([]);
};


/**
 * optional bool pro_priority = 5;
 * @return {boolean}
 */
proto.profile.SearchUsersRequest.prototype.getProPriority = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profile.SearchUsersRequest} returns this
 */
proto.profile.SearchUsersRequest.prototype.setProPriority = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional int32 delivery = 6;
 * @return {number}
 */
proto.profile.SearchUsersRequest.prototype.getDelivery = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchUsersRequest} returns this
 */
proto.profile.SearchUsersRequest.prototype.setDelivery = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool identification = 7;
 * @return {boolean}
 */
proto.profile.SearchUsersRequest.prototype.getIdentification = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profile.SearchUsersRequest} returns this
 */
proto.profile.SearchUsersRequest.prototype.setIdentification = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional int32 login_days = 8;
 * @return {number}
 */
proto.profile.SearchUsersRequest.prototype.getLoginDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchUsersRequest} returns this
 */
proto.profile.SearchUsersRequest.prototype.setLoginDays = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 user_status = 9;
 * @return {number}
 */
proto.profile.SearchUsersRequest.prototype.getUserStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchUsersRequest} returns this
 */
proto.profile.SearchUsersRequest.prototype.setUserStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * repeated string registrations = 10;
 * @return {!Array<string>}
 */
proto.profile.SearchUsersRequest.prototype.getRegistrationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.profile.SearchUsersRequest} returns this
 */
proto.profile.SearchUsersRequest.prototype.setRegistrationsList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.profile.SearchUsersRequest} returns this
 */
proto.profile.SearchUsersRequest.prototype.addRegistrations = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profile.SearchUsersRequest} returns this
 */
proto.profile.SearchUsersRequest.prototype.clearRegistrationsList = function() {
  return this.setRegistrationsList([]);
};


/**
 * optional bool business_flag = 11;
 * @return {boolean}
 */
proto.profile.SearchUsersRequest.prototype.getBusinessFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profile.SearchUsersRequest} returns this
 */
proto.profile.SearchUsersRequest.prototype.setBusinessFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profile.SearchUsersReply.repeatedFields_ = [4,8,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchUsersReply.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchUsersReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchUsersReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchUsersReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    page: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    keyword: jspb.Message.getFieldWithDefault(msg, 3, ""),
    jobIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    total: jspb.Message.getFieldWithDefault(msg, 5, 0),
    offset: jspb.Message.getFieldWithDefault(msg, 6, 0),
    maximumPage: jspb.Message.getFieldWithDefault(msg, 7, 0),
    resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.profile.UserSearch.toObject, includeInstance),
    proPriority: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    delivery: jspb.Message.getFieldWithDefault(msg, 10, 0),
    identification: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    loginDays: jspb.Message.getFieldWithDefault(msg, 12, 0),
    userStatus: jspb.Message.getFieldWithDefault(msg, 13, 0),
    registrationsList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchUsersReply}
 */
proto.profile.SearchUsersReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchUsersReply;
  return proto.profile.SearchUsersReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchUsersReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchUsersReply}
 */
proto.profile.SearchUsersReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyword(value);
      break;
    case 4:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setJobIdsList(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOffset(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaximumPage(value);
      break;
    case 8:
      var value = new proto.profile.UserSearch;
      reader.readMessage(value,proto.profile.UserSearch.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProPriority(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDelivery(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIdentification(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLoginDays(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserStatus(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.addRegistrations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchUsersReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchUsersReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchUsersReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchUsersReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getKeyword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getJobIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      4,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMaximumPage();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.profile.UserSearch.serializeBinaryToWriter
    );
  }
  f = message.getProPriority();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getDelivery();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getIdentification();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getLoginDays();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getUserStatus();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getRegistrationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      14,
      f
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.profile.SearchUsersReply.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.profile.SearchUsersReply.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string keyword = 3;
 * @return {string}
 */
proto.profile.SearchUsersReply.prototype.getKeyword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.setKeyword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated int32 job_ids = 4;
 * @return {!Array<number>}
 */
proto.profile.SearchUsersReply.prototype.getJobIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.setJobIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.addJobIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.clearJobIdsList = function() {
  return this.setJobIdsList([]);
};


/**
 * optional int32 total = 5;
 * @return {number}
 */
proto.profile.SearchUsersReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 offset = 6;
 * @return {number}
 */
proto.profile.SearchUsersReply.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 maximum_page = 7;
 * @return {number}
 */
proto.profile.SearchUsersReply.prototype.getMaximumPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.setMaximumPage = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * repeated UserSearch results = 8;
 * @return {!Array<!proto.profile.UserSearch>}
 */
proto.profile.SearchUsersReply.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.profile.UserSearch>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profile.UserSearch, 8));
};


/**
 * @param {!Array<!proto.profile.UserSearch>} value
 * @return {!proto.profile.SearchUsersReply} returns this
*/
proto.profile.SearchUsersReply.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.profile.UserSearch=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profile.UserSearch}
 */
proto.profile.SearchUsersReply.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.profile.UserSearch, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};


/**
 * optional bool pro_priority = 9;
 * @return {boolean}
 */
proto.profile.SearchUsersReply.prototype.getProPriority = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.setProPriority = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional int32 delivery = 10;
 * @return {number}
 */
proto.profile.SearchUsersReply.prototype.getDelivery = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.setDelivery = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional bool identification = 11;
 * @return {boolean}
 */
proto.profile.SearchUsersReply.prototype.getIdentification = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.setIdentification = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional int32 login_days = 12;
 * @return {number}
 */
proto.profile.SearchUsersReply.prototype.getLoginDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.setLoginDays = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 user_status = 13;
 * @return {number}
 */
proto.profile.SearchUsersReply.prototype.getUserStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.setUserStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * repeated string registrations = 14;
 * @return {!Array<string>}
 */
proto.profile.SearchUsersReply.prototype.getRegistrationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.setRegistrationsList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.addRegistrations = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profile.SearchUsersReply} returns this
 */
proto.profile.SearchUsersReply.prototype.clearRegistrationsList = function() {
  return this.setRegistrationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchProviderCompany.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchProviderCompany.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchProviderCompany} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchProviderCompany.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0),
    textJp: jspb.Message.getFieldWithDefault(msg, 2, ""),
    textEn: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchProviderCompany}
 */
proto.profile.SearchProviderCompany.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchProviderCompany;
  return proto.profile.SearchProviderCompany.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchProviderCompany} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchProviderCompany}
 */
proto.profile.SearchProviderCompany.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextJp(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextEn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchProviderCompany.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchProviderCompany.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchProviderCompany} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchProviderCompany.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTextJp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTextEn();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.profile.SearchProviderCompany.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchProviderCompany} returns this
 */
proto.profile.SearchProviderCompany.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string text_jp = 2;
 * @return {string}
 */
proto.profile.SearchProviderCompany.prototype.getTextJp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchProviderCompany} returns this
 */
proto.profile.SearchProviderCompany.prototype.setTextJp = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string text_en = 3;
 * @return {string}
 */
proto.profile.SearchProviderCompany.prototype.getTextEn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchProviderCompany} returns this
 */
proto.profile.SearchProviderCompany.prototype.setTextEn = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profile.UserSearchSpecialty.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.UserSearchSpecialty.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.UserSearchSpecialty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.UserSearchSpecialty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.UserSearchSpecialty.toObject = function(includeInstance, msg) {
  var f, obj = {
    detailsList: jspb.Message.toObjectList(msg.getDetailsList(),
    proto.profile.UserSearchSpecialtyDetail.toObject, includeInstance),
    masterCategoryId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.UserSearchSpecialty}
 */
proto.profile.UserSearchSpecialty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.UserSearchSpecialty;
  return proto.profile.UserSearchSpecialty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.UserSearchSpecialty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.UserSearchSpecialty}
 */
proto.profile.UserSearchSpecialty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.profile.UserSearchSpecialtyDetail;
      reader.readMessage(value,proto.profile.UserSearchSpecialtyDetail.deserializeBinaryFromReader);
      msg.addDetails(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMasterCategoryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.UserSearchSpecialty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.UserSearchSpecialty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.UserSearchSpecialty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.UserSearchSpecialty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.profile.UserSearchSpecialtyDetail.serializeBinaryToWriter
    );
  }
  f = message.getMasterCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * repeated UserSearchSpecialtyDetail details = 2;
 * @return {!Array<!proto.profile.UserSearchSpecialtyDetail>}
 */
proto.profile.UserSearchSpecialty.prototype.getDetailsList = function() {
  return /** @type{!Array<!proto.profile.UserSearchSpecialtyDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profile.UserSearchSpecialtyDetail, 2));
};


/**
 * @param {!Array<!proto.profile.UserSearchSpecialtyDetail>} value
 * @return {!proto.profile.UserSearchSpecialty} returns this
*/
proto.profile.UserSearchSpecialty.prototype.setDetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.profile.UserSearchSpecialtyDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profile.UserSearchSpecialtyDetail}
 */
proto.profile.UserSearchSpecialty.prototype.addDetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.profile.UserSearchSpecialtyDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profile.UserSearchSpecialty} returns this
 */
proto.profile.UserSearchSpecialty.prototype.clearDetailsList = function() {
  return this.setDetailsList([]);
};


/**
 * optional int32 master_category_id = 3;
 * @return {number}
 */
proto.profile.UserSearchSpecialty.prototype.getMasterCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.UserSearchSpecialty} returns this
 */
proto.profile.UserSearchSpecialty.prototype.setMasterCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.UserSearchSpecialtyDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.UserSearchSpecialtyDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.UserSearchSpecialtyDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.UserSearchSpecialtyDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    specialtyName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    minimumPrice: jspb.Message.getFieldWithDefault(msg, 2, 0),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.UserSearchSpecialtyDetail}
 */
proto.profile.UserSearchSpecialtyDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.UserSearchSpecialtyDetail;
  return proto.profile.UserSearchSpecialtyDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.UserSearchSpecialtyDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.UserSearchSpecialtyDetail}
 */
proto.profile.UserSearchSpecialtyDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSpecialtyName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinimumPrice(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.UserSearchSpecialtyDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.UserSearchSpecialtyDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.UserSearchSpecialtyDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.UserSearchSpecialtyDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSpecialtyName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMinimumPrice();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string specialty_name = 1;
 * @return {string}
 */
proto.profile.UserSearchSpecialtyDetail.prototype.getSpecialtyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.UserSearchSpecialtyDetail} returns this
 */
proto.profile.UserSearchSpecialtyDetail.prototype.setSpecialtyName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 minimum_price = 2;
 * @return {number}
 */
proto.profile.UserSearchSpecialtyDetail.prototype.getMinimumPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.UserSearchSpecialtyDetail} returns this
 */
proto.profile.UserSearchSpecialtyDetail.prototype.setMinimumPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.profile.UserSearchSpecialtyDetail.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.UserSearchSpecialtyDetail} returns this
 */
proto.profile.UserSearchSpecialtyDetail.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchSkill.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchSkill.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchSkill} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchSkill.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    yearsOfExperience: jspb.Message.getFieldWithDefault(msg, 2, 0),
    level: (f = msg.getLevel()) && proto.profile.SearchSkillLevel.toObject(includeInstance, f),
    description: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchSkill}
 */
proto.profile.SearchSkill.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchSkill;
  return proto.profile.SearchSkill.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchSkill} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchSkill}
 */
proto.profile.SearchSkill.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYearsOfExperience(value);
      break;
    case 3:
      var value = new proto.profile.SearchSkillLevel;
      reader.readMessage(value,proto.profile.SearchSkillLevel.deserializeBinaryFromReader);
      msg.setLevel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchSkill.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchSkill.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchSkill} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchSkill.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getYearsOfExperience();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLevel();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.profile.SearchSkillLevel.serializeBinaryToWriter
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.profile.SearchSkill.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchSkill} returns this
 */
proto.profile.SearchSkill.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 years_of_experience = 2;
 * @return {number}
 */
proto.profile.SearchSkill.prototype.getYearsOfExperience = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchSkill} returns this
 */
proto.profile.SearchSkill.prototype.setYearsOfExperience = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional SearchSkillLevel level = 3;
 * @return {?proto.profile.SearchSkillLevel}
 */
proto.profile.SearchSkill.prototype.getLevel = function() {
  return /** @type{?proto.profile.SearchSkillLevel} */ (
    jspb.Message.getWrapperField(this, proto.profile.SearchSkillLevel, 3));
};


/**
 * @param {?proto.profile.SearchSkillLevel|undefined} value
 * @return {!proto.profile.SearchSkill} returns this
*/
proto.profile.SearchSkill.prototype.setLevel = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profile.SearchSkill} returns this
 */
proto.profile.SearchSkill.prototype.clearLevel = function() {
  return this.setLevel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profile.SearchSkill.prototype.hasLevel = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.profile.SearchSkill.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchSkill} returns this
 */
proto.profile.SearchSkill.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchSkillLevel.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchSkillLevel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchSkillLevel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchSkillLevel.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0),
    textJp: jspb.Message.getFieldWithDefault(msg, 2, ""),
    textEn: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchSkillLevel}
 */
proto.profile.SearchSkillLevel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchSkillLevel;
  return proto.profile.SearchSkillLevel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchSkillLevel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchSkillLevel}
 */
proto.profile.SearchSkillLevel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextJp(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextEn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchSkillLevel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchSkillLevel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchSkillLevel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchSkillLevel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTextJp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTextEn();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.profile.SearchSkillLevel.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchSkillLevel} returns this
 */
proto.profile.SearchSkillLevel.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string text_jp = 2;
 * @return {string}
 */
proto.profile.SearchSkillLevel.prototype.getTextJp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchSkillLevel} returns this
 */
proto.profile.SearchSkillLevel.prototype.setTextJp = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string text_en = 3;
 * @return {string}
 */
proto.profile.SearchSkillLevel.prototype.getTextEn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchSkillLevel} returns this
 */
proto.profile.SearchSkillLevel.prototype.setTextEn = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchAge.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchAge.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchAge} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchAge.toObject = function(includeInstance, msg) {
  var f, obj = {
    textJp: jspb.Message.getFieldWithDefault(msg, 1, ""),
    textEn: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchAge}
 */
proto.profile.SearchAge.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchAge;
  return proto.profile.SearchAge.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchAge} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchAge}
 */
proto.profile.SearchAge.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextJp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextEn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchAge.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchAge.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchAge} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchAge.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTextJp();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTextEn();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string text_jp = 1;
 * @return {string}
 */
proto.profile.SearchAge.prototype.getTextJp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchAge} returns this
 */
proto.profile.SearchAge.prototype.setTextJp = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string text_en = 2;
 * @return {string}
 */
proto.profile.SearchAge.prototype.getTextEn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchAge} returns this
 */
proto.profile.SearchAge.prototype.setTextEn = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchProviderLevel.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchProviderLevel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchProviderLevel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchProviderLevel.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0),
    textJp: jspb.Message.getFieldWithDefault(msg, 2, ""),
    textEn: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchProviderLevel}
 */
proto.profile.SearchProviderLevel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchProviderLevel;
  return proto.profile.SearchProviderLevel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchProviderLevel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchProviderLevel}
 */
proto.profile.SearchProviderLevel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextJp(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextEn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchProviderLevel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchProviderLevel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchProviderLevel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchProviderLevel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTextJp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTextEn();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.profile.SearchProviderLevel.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchProviderLevel} returns this
 */
proto.profile.SearchProviderLevel.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string text_jp = 2;
 * @return {string}
 */
proto.profile.SearchProviderLevel.prototype.getTextJp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchProviderLevel} returns this
 */
proto.profile.SearchProviderLevel.prototype.setTextJp = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string text_en = 3;
 * @return {string}
 */
proto.profile.SearchProviderLevel.prototype.getTextEn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchProviderLevel} returns this
 */
proto.profile.SearchProviderLevel.prototype.setTextEn = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchSex.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchSex.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchSex} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchSex.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0),
    textJp: jspb.Message.getFieldWithDefault(msg, 2, ""),
    textEn: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchSex}
 */
proto.profile.SearchSex.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchSex;
  return proto.profile.SearchSex.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchSex} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchSex}
 */
proto.profile.SearchSex.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextJp(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextEn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchSex.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchSex.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchSex} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchSex.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTextJp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTextEn();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.profile.SearchSex.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchSex} returns this
 */
proto.profile.SearchSex.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string text_jp = 2;
 * @return {string}
 */
proto.profile.SearchSex.prototype.getTextJp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchSex} returns this
 */
proto.profile.SearchSex.prototype.setTextJp = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string text_en = 3;
 * @return {string}
 */
proto.profile.SearchSex.prototype.getTextEn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchSex} returns this
 */
proto.profile.SearchSex.prototype.setTextEn = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchPrefecture.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchPrefecture.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchPrefecture} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchPrefecture.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0),
    textJp: jspb.Message.getFieldWithDefault(msg, 2, ""),
    textEn: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchPrefecture}
 */
proto.profile.SearchPrefecture.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchPrefecture;
  return proto.profile.SearchPrefecture.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchPrefecture} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchPrefecture}
 */
proto.profile.SearchPrefecture.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextJp(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextEn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchPrefecture.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchPrefecture.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchPrefecture} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchPrefecture.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTextJp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTextEn();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.profile.SearchPrefecture.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchPrefecture} returns this
 */
proto.profile.SearchPrefecture.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string text_jp = 2;
 * @return {string}
 */
proto.profile.SearchPrefecture.prototype.getTextJp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchPrefecture} returns this
 */
proto.profile.SearchPrefecture.prototype.setTextJp = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string text_en = 3;
 * @return {string}
 */
proto.profile.SearchPrefecture.prototype.getTextEn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchPrefecture} returns this
 */
proto.profile.SearchPrefecture.prototype.setTextEn = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchUserStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchUserStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchUserStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchUserStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0),
    textJp: jspb.Message.getFieldWithDefault(msg, 2, ""),
    textEn: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchUserStatus}
 */
proto.profile.SearchUserStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchUserStatus;
  return proto.profile.SearchUserStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchUserStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchUserStatus}
 */
proto.profile.SearchUserStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextJp(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextEn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchUserStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchUserStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchUserStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchUserStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTextJp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTextEn();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.profile.SearchUserStatus.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchUserStatus} returns this
 */
proto.profile.SearchUserStatus.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string text_jp = 2;
 * @return {string}
 */
proto.profile.SearchUserStatus.prototype.getTextJp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchUserStatus} returns this
 */
proto.profile.SearchUserStatus.prototype.setTextJp = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string text_en = 3;
 * @return {string}
 */
proto.profile.SearchUserStatus.prototype.getTextEn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchUserStatus} returns this
 */
proto.profile.SearchUserStatus.prototype.setTextEn = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchJob.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchJob.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchJob} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchJob.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    text: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchJob}
 */
proto.profile.SearchJob.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchJob;
  return proto.profile.SearchJob.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchJob} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchJob}
 */
proto.profile.SearchJob.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchJob.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchJob.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchJob} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchJob.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.profile.SearchJob.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchJob} returns this
 */
proto.profile.SearchJob.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.profile.SearchJob.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchJob} returns this
 */
proto.profile.SearchJob.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchLicense.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchLicense.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchLicense} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchLicense.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchLicense}
 */
proto.profile.SearchLicense.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchLicense;
  return proto.profile.SearchLicense.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchLicense} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchLicense}
 */
proto.profile.SearchLicense.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchLicense.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchLicense.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchLicense} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchLicense.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.profile.SearchLicense.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchLicense} returns this
 */
proto.profile.SearchLicense.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchCareer.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchCareer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchCareer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchCareer.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jobTitle: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchCareer}
 */
proto.profile.SearchCareer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchCareer;
  return proto.profile.SearchCareer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchCareer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchCareer}
 */
proto.profile.SearchCareer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobTitle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchCareer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchCareer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchCareer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchCareer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJobTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string company_name = 1;
 * @return {string}
 */
proto.profile.SearchCareer.prototype.getCompanyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchCareer} returns this
 */
proto.profile.SearchCareer.prototype.setCompanyName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_title = 2;
 * @return {string}
 */
proto.profile.SearchCareer.prototype.getJobTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchCareer} returns this
 */
proto.profile.SearchCareer.prototype.setJobTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchAward.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchAward.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchAward} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchAward.toObject = function(includeInstance, msg) {
  var f, obj = {
    kind: jspb.Message.getFieldWithDefault(msg, 1, 0),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    winningYear: jspb.Message.getFieldWithDefault(msg, 3, 0),
    winningMonth: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchAward}
 */
proto.profile.SearchAward.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchAward;
  return proto.profile.SearchAward.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchAward} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchAward}
 */
proto.profile.SearchAward.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setKind(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWinningYear(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWinningMonth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchAward.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchAward.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchAward} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchAward.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKind();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWinningYear();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getWinningMonth();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int32 kind = 1;
 * @return {number}
 */
proto.profile.SearchAward.prototype.getKind = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchAward} returns this
 */
proto.profile.SearchAward.prototype.setKind = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.profile.SearchAward.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchAward} returns this
 */
proto.profile.SearchAward.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 winning_year = 3;
 * @return {number}
 */
proto.profile.SearchAward.prototype.getWinningYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchAward} returns this
 */
proto.profile.SearchAward.prototype.setWinningYear = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 winning_month = 4;
 * @return {number}
 */
proto.profile.SearchAward.prototype.getWinningMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchAward} returns this
 */
proto.profile.SearchAward.prototype.setWinningMonth = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchPortfolio.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchPortfolio.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchPortfolio} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchPortfolio.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    id: jspb.Message.getFieldWithDefault(msg, 4, 0),
    mediaType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    portfolioImage: (f = msg.getPortfolioImage()) && proto.profile.SearchPortfolioImage.toObject(includeInstance, f),
    portfolioVideo: (f = msg.getPortfolioVideo()) && proto.profile.SearchPortfolioVideo.toObject(includeInstance, f),
    masterCategoryId: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchPortfolio}
 */
proto.profile.SearchPortfolio.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchPortfolio;
  return proto.profile.SearchPortfolio.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchPortfolio} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchPortfolio}
 */
proto.profile.SearchPortfolio.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMediaType(value);
      break;
    case 7:
      var value = new proto.profile.SearchPortfolioImage;
      reader.readMessage(value,proto.profile.SearchPortfolioImage.deserializeBinaryFromReader);
      msg.setPortfolioImage(value);
      break;
    case 8:
      var value = new proto.profile.SearchPortfolioVideo;
      reader.readMessage(value,proto.profile.SearchPortfolioVideo.deserializeBinaryFromReader);
      msg.setPortfolioVideo(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMasterCategoryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchPortfolio.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchPortfolio.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchPortfolio} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchPortfolio.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMediaType();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPortfolioImage();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.profile.SearchPortfolioImage.serializeBinaryToWriter
    );
  }
  f = message.getPortfolioVideo();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.profile.SearchPortfolioVideo.serializeBinaryToWriter
    );
  }
  f = message.getMasterCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.profile.SearchPortfolio.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchPortfolio} returns this
 */
proto.profile.SearchPortfolio.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.profile.SearchPortfolio.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchPortfolio} returns this
 */
proto.profile.SearchPortfolio.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 id = 4;
 * @return {number}
 */
proto.profile.SearchPortfolio.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchPortfolio} returns this
 */
proto.profile.SearchPortfolio.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 media_type = 5;
 * @return {number}
 */
proto.profile.SearchPortfolio.prototype.getMediaType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchPortfolio} returns this
 */
proto.profile.SearchPortfolio.prototype.setMediaType = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional SearchPortfolioImage portfolio_image = 7;
 * @return {?proto.profile.SearchPortfolioImage}
 */
proto.profile.SearchPortfolio.prototype.getPortfolioImage = function() {
  return /** @type{?proto.profile.SearchPortfolioImage} */ (
    jspb.Message.getWrapperField(this, proto.profile.SearchPortfolioImage, 7));
};


/**
 * @param {?proto.profile.SearchPortfolioImage|undefined} value
 * @return {!proto.profile.SearchPortfolio} returns this
*/
proto.profile.SearchPortfolio.prototype.setPortfolioImage = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profile.SearchPortfolio} returns this
 */
proto.profile.SearchPortfolio.prototype.clearPortfolioImage = function() {
  return this.setPortfolioImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profile.SearchPortfolio.prototype.hasPortfolioImage = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional SearchPortfolioVideo portfolio_video = 8;
 * @return {?proto.profile.SearchPortfolioVideo}
 */
proto.profile.SearchPortfolio.prototype.getPortfolioVideo = function() {
  return /** @type{?proto.profile.SearchPortfolioVideo} */ (
    jspb.Message.getWrapperField(this, proto.profile.SearchPortfolioVideo, 8));
};


/**
 * @param {?proto.profile.SearchPortfolioVideo|undefined} value
 * @return {!proto.profile.SearchPortfolio} returns this
*/
proto.profile.SearchPortfolio.prototype.setPortfolioVideo = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profile.SearchPortfolio} returns this
 */
proto.profile.SearchPortfolio.prototype.clearPortfolioVideo = function() {
  return this.setPortfolioVideo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profile.SearchPortfolio.prototype.hasPortfolioVideo = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional int32 master_category_id = 9;
 * @return {number}
 */
proto.profile.SearchPortfolio.prototype.getMasterCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchPortfolio} returns this
 */
proto.profile.SearchPortfolio.prototype.setMasterCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchPortfolioImage.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchPortfolioImage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchPortfolioImage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchPortfolioImage.toObject = function(includeInstance, msg) {
  var f, obj = {
    thumbnailUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchPortfolioImage}
 */
proto.profile.SearchPortfolioImage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchPortfolioImage;
  return proto.profile.SearchPortfolioImage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchPortfolioImage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchPortfolioImage}
 */
proto.profile.SearchPortfolioImage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbnailUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchPortfolioImage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchPortfolioImage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchPortfolioImage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchPortfolioImage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getThumbnailUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string thumbnail_url = 1;
 * @return {string}
 */
proto.profile.SearchPortfolioImage.prototype.getThumbnailUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchPortfolioImage} returns this
 */
proto.profile.SearchPortfolioImage.prototype.setThumbnailUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchPortfolioVideo.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchPortfolioVideo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchPortfolioVideo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchPortfolioVideo.toObject = function(includeInstance, msg) {
  var f, obj = {
    url: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchPortfolioVideo}
 */
proto.profile.SearchPortfolioVideo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchPortfolioVideo;
  return proto.profile.SearchPortfolioVideo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchPortfolioVideo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchPortfolioVideo}
 */
proto.profile.SearchPortfolioVideo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchPortfolioVideo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchPortfolioVideo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchPortfolioVideo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchPortfolioVideo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.profile.SearchPortfolioVideo.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchPortfolioVideo} returns this
 */
proto.profile.SearchPortfolioVideo.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profile.SearchPrice.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchPrice.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchPrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchPrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchPrice.toObject = function(includeInstance, msg) {
  var f, obj = {
    priceItemsList: jspb.Message.toObjectList(msg.getPriceItemsList(),
    proto.profile.SearchPriceItem.toObject, includeInstance),
    masterCategoryId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchPrice}
 */
proto.profile.SearchPrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchPrice;
  return proto.profile.SearchPrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchPrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchPrice}
 */
proto.profile.SearchPrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.profile.SearchPriceItem;
      reader.readMessage(value,proto.profile.SearchPriceItem.deserializeBinaryFromReader);
      msg.addPriceItems(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMasterCategoryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchPrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchPrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchPrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchPrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPriceItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.profile.SearchPriceItem.serializeBinaryToWriter
    );
  }
  f = message.getMasterCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * repeated SearchPriceItem price_items = 2;
 * @return {!Array<!proto.profile.SearchPriceItem>}
 */
proto.profile.SearchPrice.prototype.getPriceItemsList = function() {
  return /** @type{!Array<!proto.profile.SearchPriceItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profile.SearchPriceItem, 2));
};


/**
 * @param {!Array<!proto.profile.SearchPriceItem>} value
 * @return {!proto.profile.SearchPrice} returns this
*/
proto.profile.SearchPrice.prototype.setPriceItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.profile.SearchPriceItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profile.SearchPriceItem}
 */
proto.profile.SearchPrice.prototype.addPriceItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.profile.SearchPriceItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profile.SearchPrice} returns this
 */
proto.profile.SearchPrice.prototype.clearPriceItemsList = function() {
  return this.setPriceItemsList([]);
};


/**
 * optional int32 master_category_id = 3;
 * @return {number}
 */
proto.profile.SearchPrice.prototype.getMasterCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchPrice} returns this
 */
proto.profile.SearchPrice.prototype.setMasterCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profile.SearchPriceItem.prototype.toObject = function(opt_includeInstance) {
  return proto.profile.SearchPriceItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profile.SearchPriceItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchPriceItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    daysToDelivery: jspb.Message.getFieldWithDefault(msg, 2, 0),
    minimumPrice: jspb.Message.getFieldWithDefault(msg, 3, 0),
    note: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profile.SearchPriceItem}
 */
proto.profile.SearchPriceItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profile.SearchPriceItem;
  return proto.profile.SearchPriceItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profile.SearchPriceItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profile.SearchPriceItem}
 */
proto.profile.SearchPriceItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDaysToDelivery(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinimumPrice(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profile.SearchPriceItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profile.SearchPriceItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profile.SearchPriceItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profile.SearchPriceItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDaysToDelivery();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMinimumPrice();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.profile.SearchPriceItem.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchPriceItem} returns this
 */
proto.profile.SearchPriceItem.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 days_to_delivery = 2;
 * @return {number}
 */
proto.profile.SearchPriceItem.prototype.getDaysToDelivery = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchPriceItem} returns this
 */
proto.profile.SearchPriceItem.prototype.setDaysToDelivery = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 minimum_price = 3;
 * @return {number}
 */
proto.profile.SearchPriceItem.prototype.getMinimumPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.profile.SearchPriceItem} returns this
 */
proto.profile.SearchPriceItem.prototype.setMinimumPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string note = 4;
 * @return {string}
 */
proto.profile.SearchPriceItem.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.profile.SearchPriceItem} returns this
 */
proto.profile.SearchPriceItem.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


goog.object.extend(exports, proto.profile);
